/* eslint-disable no-unused-vars */
import i18n from '@/js/plugins/i18n';
import useUsersStore from '@/stores/users';
import img from '../img/step2assign.svg';

export default {
  id: 'step2assign',
  img,
  imgBg: 'linear-gradient(to right, #E6DAFF 0%, #E6DAFF 50%, #F7D1D3 50%, #F7D1D3 100%)',
  defaultConf() {
    return {
      mappings: [{
        stepLabel: i18n.global.t('KANBAN.VALIDATED'),
        userIds: [],
      }],
    };
  },
  canRun({ planning, element, oldData, newData, automation }) {
    if (newData.processStep == oldData.processStep) return false;
    const newStepLabel = planning.process?.steps?.find(step => step.id == newData.processStep)?.label.trim();
    return automation.conf?.mappings?.some(item => item.stepLabel.trim() == newStepLabel);
  },
  run({ planning, element, oldData, newData, automation }, showToast) {
    const newStepLabel = planning.process?.steps?.find(step => step.id == newData.processStep)?.label.trim();
    const currentUserIds = new Set(element.getUsers()?.map(user => user.id));
    const userIds = new Set();
    automation.conf?.mappings.forEach((mapping) => {
      if (mapping.stepLabel.trim() == newStepLabel) {
        mapping.userIds?.forEach((userId) => {
          if (! currentUserIds.has(userId)) userIds.add(userId);
        });
      }
    });
    if (! userIds.size) return;

    if (showToast) showToast();
    const usersStore = useUsersStore();
    userIds.forEach(id => element.addUser(usersStore.getUserById(id)));
  },
};
